import { logCustomDatadogAction } from "../scripts/shared_setup"
import detectPlatform from "shared/detect_platform"
import { trackHomepageAiSectionClicked, trackHomepageAiSectionShown } from "app/utils/mixpanel_tracking"
import { watchScrollDepth } from "app/utils/scroll_depth"

const trackAiSection = () => {
  const section = document.querySelector(".ai-workflows-module")
  if (!section) return

  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) return
    trackHomepageAiSectionShown()
    observer.disconnect()
  })
  observer.observe(section)

  section.querySelectorAll("a[data-ai-section-cta]").forEach(link => {
    link.addEventListener("click", () => {
      trackHomepageAiSectionClicked({ cta: link.dataset.aiSectionCta, destination: link.pathname })
    })
  })
}

// Before its section first renders, the logo strip cannot run on the compositor, and while it
// ticks Chrome recalculates style every frame, the hero collage's included. It moves on screen only.
export function watchBrandStrip() {
  const brandTestimonials = document.querySelector(".brand-testimonials")
  if (brandTestimonials) {
    new IntersectionObserver(([entry]) =>
      brandTestimonials.classList.toggle("is-onscreen", entry.isIntersecting),
    ).observe(brandTestimonials)

    // Focus scrolls the clipped strip only for a logo fully out of view; center the rest too,
    // clear of the faded edges.
    brandTestimonials.addEventListener("focusin", event => {
      if (event.target.closest(".brand-testimonials__logo")) {
        event.target.scrollIntoView({ block: "nearest", inline: "center" })
      }
    })
  }
}

export default async function ProsumerHome(opts = {}) {
  const hero = document.querySelector("[data-hero-section]")

  if (hero) {
    logCustomDatadogAction("header_impression", { platform: detectPlatform() })

    // The collages run on the compositor, but their ~230 CSS animations still tick. They start
    // once the page has loaded (a 240s turn makes the wait invisible) and pause off screen.
    const startAnimations = () => hero.classList.add("is-animating")
    if (document.readyState === "complete") {
      startAnimations()
    } else {
      window.addEventListener("load", startAnimations, { once: true })
    }
    new IntersectionObserver(([entry]) => hero.classList.toggle("is-offscreen", !entry.isIntersecting)).observe(hero)
  }

  watchBrandStrip()

  const ctaButton = document.querySelector("[data-cta-text]")
  if (ctaButton) {
    ctaButton.addEventListener("click", () => {
      logCustomDatadogAction("header_cta_clicked", {
        cta_text: ctaButton.dataset.ctaText,
        platform: detectPlatform(),
      })
    })
  }

  if (hero) {
    watchScrollDepth("home")
    trackAiSection()
  }

  // Plan type toggle
  const planToggle = document.querySelector(".toggle")
  const prices = opts.prices
  const urls = opts.urls
  planToggle?.addEventListener("click", function (e) {
    e.preventDefault()
    this.classList.toggle("active")

    const proPlanLinks = document.querySelectorAll("a[data-plan-page='true']")
    const proPriceDisplay = document.querySelector(".pro-plus.price-amount")
    const proYearlyPriceDisplay = document.querySelector(".pro-plus.yearly-price")

    const intermediatePlanLinks = document.querySelectorAll("a[data-intermediate-plan-page='true']")
    const intermediatePriceDisplay = document.querySelector(".intermediate-pro.price-amount")
    const intermediateYearlyPriceDisplay = document.querySelector(".intermediate-pro.yearly-price")

    const interval = this.classList.contains("active") ? "yearly" : "monthly"

    proPlanLinks.forEach(link => {
      link.setAttribute("href", urls.pro_plus[interval])
    })
    proPriceDisplay.innerHTML = prices.pro_plus[interval]
    intermediatePlanLinks.forEach(link => {
      link.setAttribute("href", urls.intermediate_pro[interval])
    })

    intermediatePriceDisplay.innerHTML = prices.intermediate_pro[interval]

    proYearlyPriceDisplay.classList.toggle("hidden")
    intermediateYearlyPriceDisplay.classList.toggle("hidden")
    document.querySelectorAll(".yearly-price-spacer").forEach(el => {
      el.classList.toggle("hidden")
    })
  })
}
